import React, { Component } from 'react';
import {Input, Modal, Form,Icon, Button, Radio,message, Select, DatePicker, InputNumber } from 'antd';
import {getcbdcountrynames,projectTitle,klicountrynames,holdWip} from '../../stores/APIEndpoints';
import DashboardArbitratorStore from '../../stores/DashboardArbitratorStore';
import {appStore} from '../../stores/AppStore';
import {inject, observer} from 'mobx-react';
import '../../../src/index.css';
import moment from 'moment';
let slectmulDates = [];
const { TextArea } = Input;
@inject('dataStore')
@observer
class LooseLeafArbitratorPrimaryInformationDrawer extends Component {
  
    constructor(props) {
        super(props);
        this.apiProxy = appStore.apiProxy;
        this.state = {
            countryList:'',
            titleList:'',
            visible: false,
            holdComment:'',
            hold:'false',
            commentBox:false,
            currentHoldStatus:''
          }
    }
    get store() {
        return DashboardArbitratorStore;
     }
   
    async componentDidMount() {
        this.getCountry();
        this.getTitle();
        this.setState({currentHoldStatus:this.store.currentData.holdStatus});
      }  
    getCountry = async () => {
        const bodyParams = { "select": ["id", "name" ], "where": []};
        let response = await this.apiProxy.asyncPost(getcbdcountrynames, bodyParams);
        const option = await response.json();
        this.setState({countryList:option});
      };
    getTitle = async () => {
        let response = await this.apiProxy.getAsync(projectTitle);
        const option = await response.json();
        this.setState({titleList:option});
      };
  
  


  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        let data={};
            data.titleId = values.titleId;
            data.countryId = values.countryId;
            data.classification = values.classification;
            data.lapsId = values.lapsId;
            data.publishoneId = values.publishoneId;
            data.vendor = values.vendor;
            data.doNotChase = values.doNotChase;
            data.freelancerChaseDate = values.freelancerChaseDate;
            data.projectStartDate = values.projectStartDate;

          if(this.store.currentData.id != undefined)
          {  
            data.notes = values.notes;
            data.note1 = values.note1;
            data.note2 = values.note2;
            data.ctp = values.ctp;
          
            data.reviewType = values.reviewType;
            data.category = values.category;
            data.grade = values.grade; 
            data.lastSupplement = values.lastSupplement;
            data.doNotChase = values.doNotChase;
              // if(values.projectStartDate !="")
              // {
              //     data.projectStartDate = values.projectStartDate.year()+'-'+(values.projectStartDate.month()+1)+'-'+values.projectStartDate.date();
              // }
              // if(values.lastUpdatedDate !="")
              // {
              //     data.lastUpdatedDate = values.lastUpdatedDate.year()+'-'+(values.lastUpdatedDate.month()+1)+'-'+values.lastUpdatedDate.date();
              // }
              if(appStore.credentials.userId==2472)
              {
                if(values.lastPublishedDate !="")
                {
                    data.lastPublishedDate = values.lastPublishedDate.year()+'-'+(values.lastPublishedDate.month()+1)+'-'+values.lastPublishedDate.date();
                }
              }
             
            data.authorQuery = values.authorQuery
            data.filesSent = values.filesSent; 
            data.filesReceived = values.filesReceived
            // data.comments = values.comments 
          }
            data.wip_authorNames =this.store.currentData.authorNames;
            data.wip_authorEmails = this.store.currentData.authorEmails;
            data.wip_cmNames = this.store.currentData.cmNames;
            data.wip_cmEmails = this.store.currentData.cmEmails;
            data.wip_freelancerNames = this.store.currentData.freelancerNames;
            data.wip_freelancerEmails = this.store.currentData.freelancerEmails;
            data.projectStartDate = this.store.currentData.projectStartDate;
        this.store.updateItem(data);
      }
    });
  };
  countryChange =async(value)=>{
    
  const bodyParams = {
            "where": {id: value.toString()},
            "limit": "5"
      }
  let response = await this.apiProxy.asyncPost(klicountrynames, bodyParams);
  const option = await response.json();
  this.store.getCountryName=option[0].country;
}
onChangeDoNotChase=async(value)=>{
   this.setState({hold:value.target.value});
  this.showModal();
}
onChangeVendorData=async(values)=>{
  this.store.currentData.vendor=values;
 }
showModal = () => {
  this.setState({
    visible: true,
  });
};
handleOk = e => {
  if(this.state.hold == "true")
  {
    if(this.state.holdComment == '' || this.state.holdComment != 'Stop Chasing')
    {
      this.setState({commentBox:true});
      return false;
    }
    else
    {
      this.getUpdateWip();
      this.setState({commentBox:false});
    }
  }
  else
  {
    if(this.state.holdComment=='Start Chasing')
    {
      this.getUpdateWip();
      this.setState({commentBox:false});
    }
    else
    {
      this.setState({commentBox:true});
      return false;
    }
  }
};

getUpdateWip = async()=>{
  let status = false;
  if(this.state.hold == 'true')
  {
    status = true;
  }
  
  const bodyParams = {
    "project_id":this.store.currentData.projectId,
    "reason": "external",
    "status": status,
    "comment": this.state.holdComment,
  }
  let response = await this.apiProxy.asyncPost(holdWip, bodyParams);
  const option = await response.json();
  if(option.message=="The project is paused successfully.")
  {
    this.setState({visible: false});
    this.setState({hold: false });
    this.setState({holdComment: '' });
    this.setState({commentBox:false});
    message.success('The project is paused successfully.');
    this.store.fetchData();
  }
  else if(option.message=="The project is now released.")
  {
    this.setState({visible: false});
    this.setState({hold: false });
    this.setState({holdComment: '' });
    this.setState({commentBox:false});
    message.success('The project is now released.');
    this.store.fetchData();
  }
  else
  {
    message.success(option.message);
    this.setState({visible: false});
    this.setState({hold: false });
    this.setState({holdComment: '' });
    this.setState({hold: this.store.currentData.holdStatus});
  }
 }
 onChangeLastUpdatedDate=async(values)=>{
  const newdate = new Date(values);
  if(this.store.currentData.abbreviation == "MIP")
     {
       if(this.store.currentData.recyclePeriod == 0 || this.store.currentData.recyclePeriod == "" || this.store.currentData.recyclePeriod == undefined ||  this.store.currentData.recyclePeriod == null)
       {
        message.error('Recycle period count is empty.');
        return false;
       }
      let dateCount = await this.mapToWorkdays(newdate, this.store.currentData.recyclePeriod);
      this.store.currentData.projectStartDate=new Date(newdate.setDate(newdate.getDate() + dateCount));
     }
 }
 onChangelastPublishedDate=async(values)=>{
  const newdate = new Date(values);
  if(this.store.currentData.abbreviation != "MIP")
     {
       if(this.store.currentData.recyclePeriod == 0 || this.store.currentData.recyclePeriod == "" || this.store.currentData.recyclePeriod == undefined ||  this.store.currentData.recyclePeriod == null)
       {
        message.error('Recycle period count is empty.');
        return false;
       }
      let dateCount = await this.mapToWorkdays(newdate, this.store.currentData.recyclePeriod);
      this.store.currentData.projectStartDate=new Date(newdate.setDate(newdate.getDate() + dateCount));
     }
 }

 mapToWorkdays=async(date, add)=> {
  const wd = this.weekday(date)
  
  let r = Math.trunc(add / 5) * 2
  const rem = add % 5

  if (wd > 4) r += (6-wd)
  else if (wd+rem > 4) r += 2
  
  return add + r;
}
weekday=(date)=> { return (date.getUTCDay()+ 6) % 7 }

handleCancel = e => {
  console.log(e);
  this.setState({
    visible: false
  });
  this.setState({
    holdComment: ''
  });
  this.setState({commentBox:false});
  // const val = this.state.currentHoldStatus;
  // this.setState({hold:val});
};
userComents =(value) => {
 this.setState({holdComment:value.target.value});
}

  render() {
     const { getFieldDecorator } = this.props.form;
     const userId = appStore.credentials;
     const data = this.store.currentData;
     //const title = data.id === undefined ? "New Title" : data.abbreviation + " - " + data.publication;
     const {countryList,titleList, hold} = this.state;
    
    
    return (
      <div>
        <Form name="normal_login" className="login-form" initialValues={{ remember: true }} onSubmit={this.handleSubmit}>
        <Form.Item label="Title"  name="titleId">
            {getFieldDecorator('titleId', {
                 initialValue:data.titleId,
                 rules: [{required: true}]
            })(
                <Select showSearch disabled={data.id != undefined}  placeholder="Select a title" optionFilterProp="children">
                {titleList != "" ? titleList.map(value =>  <Option value={value.id}>{value.shortTitle}</Option>) : <Option value=''>''</Option>}
                </Select>
            )}
        </Form.Item>
        <Form.Item label="Document Name"  name="classification">
            {getFieldDecorator('classification', {
                 initialValue:data.classification,
                 rules: []
            })(
              <Input style={{ width: '100%' }} />
            )}
        </Form.Item>
        <Form.Item label="LAPS ID"  name="lapsId">
            {getFieldDecorator('lapsId', {
                 initialValue:data.lapsId,
                 rules: []
            })(
              <Input style={{ width: '100%' }} />
            )}
           </Form.Item>
           <Form.Item label="PublishOne ID"  name="publishoneId">
            {getFieldDecorator('publishoneId', {
                 initialValue:data.publishoneId,
                 rules: []
            })(
              <Input style={{ width: '100%' }} />
            )}
           </Form.Item>
           <Form.Item label="Country"  name="countryId">
            {getFieldDecorator('countryId', {
                 initialValue:data.countryId,
                 rules: []
            })(
              <Select showSearch placeholder="Select a country" onChange={this.countryChange} optionFilterProp="children">
                {countryList != "" ? countryList.map(value =>  <Option value={value.id}>{value.name}</Option>) : <Option value=''>''</Option>}
                </Select>
            )}
        </Form.Item>
           <Form.Item label="Vendor"  name="vendor">
            {getFieldDecorator('vendor', {
                 initialValue:data.vendor,
                 rules: []
            })(
              <Select defaultValue="PubKit" onChange={this.onChangeVendorData} >
                  <Option value="PubKit">PubKit</Option>
                  <Option value="LAPS">LAPS</Option>
                  <Option value="PublishOne">PublishOne</Option>
              </Select>
            )}
        </Form.Item>
        {data.projectId < 0 || data.projectId == null?
        <Form.Item label="Do Not Chase"  name="doNotChase">
            {getFieldDecorator('doNotChase', {
                 initialValue:data.doNotChase,
                 rules: []
            })(
              <Radio.Group>
              <Radio value={true}>Yes</Radio>
              <Radio value={false}>No</Radio>
            </Radio.Group>
            )}
        </Form.Item>:''}
        {data.projectId > 0 ?
        <Form.Item label="Do Not Chase"  name="holdStatus">
            {getFieldDecorator('holdStatus', {
                 initialValue:data.holdStatus,
                 rules: []
            })(
              <Radio.Group defaultValue={this.state.hold} onChange={this.onChangeDoNotChase}>
              <Radio value={'true'}>Yes</Radio>
              <Radio value={'false'}>No</Radio>
            </Radio.Group>
            )}
        </Form.Item>:''}
        {data.id != undefined ?
        <div>
        <Form.Item label="Notes 1"  name="notes">
            {getFieldDecorator('notes', {
                 initialValue:data.notes,
                 rules: []
            })(
              <TextArea rows={2} />
            )}
        </Form.Item>
         <Form.Item label="Notes 2"  name="note1">
            {getFieldDecorator('note1', {
                 initialValue:data.note1,
                 rules: []
            })(
              <TextArea rows={2} />
            )}
        </Form.Item>
         <Form.Item label="Notes 3"  name="note2">
            {getFieldDecorator('note2', {
                 initialValue:data.note2,
                 rules: []
            })(
              <TextArea rows={2} />
            )}
        </Form.Item>
        </div>:''}
      <Form.Item>
          <Button style={{"float":"right","margin-top":"10px"}} type="primary"  htmlType="submit" className="login-form-button">Save</Button>
        </Form.Item>
      </Form>
    

      <Modal
        //title={title}
        visible={this.state.visible}
        onOk={this.handleOk}
        onCancel={this.handleCancel}
      >
        {hold == "true" ?
        <div>
            <div>Please type "<b>Stop Chasing</b>" to stop chasing.</div>
            <br/>
            <Input value={this.state.holdComment} onChange={this.userComents} placeholder={"Stop Chasing"} />
            {this.state.commentBox? <div style={{"color":"red"}}><sup>*</sup>Text not matching...</div>:''}
        </div>:
        <div>
          <div>Please type "<b>Start Chasing</b>" to resume chasing.</div>
          <br/>
          <Input value={this.state.holdComment} onChange={this.userComents} placeholder={"Start Chasing"} />
          {this.state.commentBox? <div style={{"color":"red"}}><sup>*</sup>Text not matching...</div>:''}
      </div>}
    </Modal>
    </div>
    );
  }
}

export default Form.create({ name: 'normal_login' })(LooseLeafArbitratorPrimaryInformationDrawer);

// export default WrappedNormalLoginForm;

